export const FIELD_INDEXING_DEFAULT = "*" as const;
